import Vue from 'vue';
import App from './App.vue';
import FormComponentsMixin from '@/shared/components/FormComponentsMixin';
import VuexI18n from 'vuex-i18n';
import Vuex from 'vuex';

import '@/shared/assets/css/general-styles.css';
import { store } from './store';
import danishForm from './translations/form/da_form.js';
import danishContract from './translations/contract/da_contract.js';
import '@/web.config';

Vue.use(Vuex);

// Initial translations
Vue.use(VuexI18n.plugin, store);
Vue.i18n.add('da-DK', {
  ...danishForm,
  ...danishContract,
});
Vue.i18n.set('da-DK');

Vue.config.productionTip = false;

Vue.mixin(FormComponentsMixin);

new Vue({
  store,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/apps/eneforhandler/main.js